import { z } from 'zod';
import { uuidSchema } from './common.js';
export const mockupQualitySchema = z.enum(['standard', 'hd']);
export const generateMockupSchema = z.object({
    sourceMediaId: uuidSchema.optional(),
    quality: mockupQualitySchema.default('standard'),
});
export const mockupSchema = z.object({
    id: uuidSchema,
    quality: mockupQualitySchema,
    status: z.enum(['pending', 'succeeded', 'failed']),
    url: z.string().nullable(),
    thumbUrl: z.string().nullable(),
    creditsSpent: z.number().int(),
    cacheHit: z.boolean(),
    attached: z.boolean(),
    createdAt: z.string(),
    completedAt: z.string().nullable(),
    errorCode: z.enum(['provider_unavailable', 'provider_timeout', 'no_image_returned', 'insufficient_credits', 'credit_consume_failed', 'stale_pending', 'unknown']).nullable(),
});
export const generateMockupResponseSchema = z.object({
    mockup: mockupSchema,
    creditsBalance: z.number().int(),
});
export const setMockupAttachedSchema = z.object({
    attached: z.boolean(),
});
export const mockupHistoryItemSchema = mockupSchema.extend({
    quoteId: uuidSchema,
    quoteNumber: z.number().int(),
});
export const attachExistingMockupSchema = z.object({
    mockupId: uuidSchema,
});
//# sourceMappingURL=mockups.js.map